import { Flex, Text } from "@chakra-ui/react";
import utils from "utils";

const CardAmount = ({ data, color, type }) => {
  if (type === "simple") {
    return (
      <Flex
        w={"18rem"}
        borderRadius={"0.5rem"}
        bg={color || "fontdark"}
        p={"0.5rem"}
        gap={"1rem"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Text color={"white"} textStyle={"md"}>
          {data?.label1 || ""}
        </Text>
        {data?.label2 ? (
          <Text color={"white"} textStyle={"md"}>
            {data?.label2 || ""}
          </Text>
        ) : null}
      </Flex>
    );
  }

  return (
    <Flex
      w={"18rem"}
      borderRadius={"0.5rem"}
      bg={color || "fontdark"}
      p={"0.5rem"}
      gap={"1rem"}
    >
      <Flex flexDirection={"column"} flex={1}>
        <Text color={"white"} textStyle={"md"}>
          {data?.label1 || ""}
        </Text>
        <Text color={"white"} textStyle={"sm"}>
          {data?.label2 || ""}
        </Text>
      </Flex>

      <Flex alignItems={"center"}>
        {/* <Text color={"white"} textStyle={"sm"}>
             $
           </Text> */}
        {/* <Separator
             bg={"white"}
             h={"100%"}
             w={"0.1rem"}
             ml={"0.5rem"}
             mr={"0.5rem"}
             orientation={"vertical"}
             colorPalette={"white"}
           /> */}
        <Flex flexDirection={"column"}>
          <Text color={"white"} textStyle={"md"}>
            {utils.formatCurrency(data?.value1)}
          </Text>
          <Text color={"white"} textStyle={"sm"} textAlign={"right"}>
            {utils.formatCurrency(data?.value2)}
            {/* {data?.value2 || ""} */}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CardAmount;
